import { Children, memo, ReactNode } from "react";
import classNames from "classnames";

import styles from "../style.module.scss";

type DropContainerBodyProps = {
  className?: string,
  children?: ReactNode
  close?: () => void
}

export const DropContainerBody = memo<DropContainerBodyProps>((
  {
    className,
    children,
    close,
  }) => {

  if (!Children.count(children)) {
    return null;
  }

  return (
    <div className={classNames(styles.dropdown, className)} onMouseLeave={close}>
      <ul className={styles.dropWrap}>
        {children}
      </ul>
    </div>
  );
});
